enum TanglRemarkMessageTypeEnum {
    Click = 'Click',
    SetPosition = 'SetPosition',
    AddOnScene = 'AddOnScene',
    RemoveFromScene = 'RemoveFromScene',
    ZoomCamera = 'ZoomCamera',
    ToolChanged = 'ToolChanged',
}

export default TanglRemarkMessageTypeEnum;
